import React from 'react';

export default () => {
    const user = JSON.parse(localStorage.getItem('avi-user'));
    const firstName = user ? user.fullName : '';

    console.log(user, "whatUser");
    return (
        <div className="view-header">
            <header className="title text-white">
                <h1 className="h4 text-uppercase">Dashboard</h1>
                <p className="mb-0">Welcome to your dashboard {firstName} &#x1F600;</p>
            </header>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/views/avicollectDashboard/view-header.js